import yup from 'src/libraries/validator.library';
import {
  FlightTypesListSchema,
  FlightTypeFormSchema,
  IFlightTypeForm,
} from 'src/models/flight-type.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('flightTypes', { limit: 0 }, FlightTypesListSchema);
  },
  updatePUT: async (id: number, data: IFlightTypeForm) => {
    return http.put(`flightTypes/${id}`, data, FlightTypeFormSchema);
  },
  addPOST: async (data: IFlightTypeForm) => {
    return http.post('flightTypes', data, FlightTypeFormSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`flightTypes/${id}`, yup.mixed());
  },
};

export default services;
